/**
 * @fileoverview Implementación del cliente de contraseña de portal-api-zonasegura (vía Apigee).
 * Envía `x-api-key` y las cabeceras de trazabilidad que exige Apigee; el CORS de portal-api las acepta.
 * @module integrations/impl/password.integration.impl
 */

import axios from 'axios'
import environment, { ORIGIN } from '../../utils/environment'
import { buildApigeeHeaders } from '../../utils/apigeeHeaders'
import { toIntegrationError, logIntegrationError } from './integration-error'

const TIMEOUT_MS = 30000
const INTEGRATION_NAME = 'portal-api'

/**
 * Crea el cliente HTTP de portal-api.
 * @returns {Object} Instancia de axios
 */
export function createPasswordHttpClient () {
  return axios.create({
    baseURL: environment.getPortalApiUrl(),
    timeout: TIMEOUT_MS,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * Crea la implementación del contrato PasswordIntegration.
 * @param {Object} [http] - Instancia de axios (inyectable en tests)
 * @returns {import('../password.integration').PasswordIntegration}
 */
export function createPasswordIntegration (http = createPasswordHttpClient()) {
  return {
    setup: (passwordSetupToken, newPassword) => http.post('auth/password/setup', { newPassword, origen: ORIGIN }, {
      headers: { ...buildApigeeHeaders(), Authorization: `Bearer ${passwordSetupToken}` }
    })
      .then(res => res.data)
      .catch(error => {
        const integrationError = toIntegrationError(error)
        logIntegrationError(INTEGRATION_NAME, 'setup', integrationError)
        throw integrationError
      })
  }
}



// WEBPACK FOOTER //
// ./src/integrations/impl/password.integration.impl.js